import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useEventLogger } from '../useEventLogger.mjs';
import useReferenceSafeObject from '../utils/useReferenceSafeObject.mjs';
import useOnce from '../utils/useOnce.mjs';

function ViewV2(props) {
  return props.fireInView ? /* @__PURE__ */ jsx(ViewWithInView, { ...props }) : /* @__PURE__ */ jsx(ViewRaw, { ...props });
}
function ViewRaw(props) {
  const { eventProperties: eventPropertiesRaw, children, once = true } = props;
  const eventProperties = useReferenceSafeObject(eventPropertiesRaw);
  const { view: viewRaw } = useEventLogger();
  const viewOnce = useOnce(viewRaw);
  const view = once ? viewOnce : viewRaw;
  useEffect(() => {
    view(eventProperties);
  }, [view, eventProperties]);
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function ViewWithInView(props) {
  const { eventProperties: eventPropertiesRaw, children, once = true } = props;
  const eventProperties = useReferenceSafeObject(eventPropertiesRaw);
  const { ref: observerRef, inView } = useInView();
  const { view: viewRaw } = useEventLogger();
  const viewOnce = useOnce(viewRaw);
  const view = once ? viewOnce : viewRaw;
  useEffect(() => {
    if (inView) {
      view(eventProperties);
    }
  }, [view, inView, eventProperties]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IntersectionObserverTarget, { "aria-hidden": "true", ref: observerRef }),
    children
  ] });
}
const IntersectionObserverTarget = "div";

export { ViewV2 as default };
//# sourceMappingURL=View.mjs.map
